module.exports = __webpack_public_path__ + "img/20190529162021QQ截图20190527165053.676b3edd.png";